module.exports = __webpack_public_path__ + "static/media/report_1-10_desktop.acb409ae.png";